import React, { Fragment, FC } from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../store/reducers'

const Loader: FC<{
  authLoading: boolean
  songsLoading: boolean
  dataLoading: boolean
}> = ({ authLoading, songsLoading, dataLoading }) => {
  return (
    <Fragment>
      {authLoading || songsLoading || dataLoading ? (
        <div className="loader">
          <span uk-spinner="ratio: 4.5" style={{ margin: 'auto' }}></span>
        </div>
      ) : (
        <Fragment></Fragment>
      )}
    </Fragment>
  )
}

const mapStateToProps = (state: RootState) => ({
  authLoading: state.auth.loading,
  songsLoading: state.songs.loading,
  dataLoading: state.data.loading,
})

export default connect(mapStateToProps)(Loader)
